import { getFirestore, doc, getDoc, setDoc } from "firebase/firestore";
import firebaseApp from "@/lib/firebase";

/**
 * Repository class for settings collection operations
 * Handles CRUD operations for settings in Firestore
 */
export class SettingsRepository {
  private db = getFirestore(firebaseApp);
  private collectionName = "settings" as const;
  /**
   * Set or update a specific setting for a user
   */
  async setUserSetting(
    userId: string,
    key: string,
    value: boolean
  ): Promise<void> {
    const ref = doc(this.db, this.collectionName, userId);
    // Use merge to only update the specific key
    await setDoc(ref, { [key]: value }, { merge: true });
  }

  /**
   * Get all settings for a user by userId
   */
  async getSettingsByUserId(
    userId: string
  ): Promise<{ [key: string]: boolean } | null> {
    const ref = doc(this.db, this.collectionName, userId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    return { ...snap.data() };
  }
}

// Export singleton instance
export const settingsRepository = new SettingsRepository();
